import { Image, UIHeading4, Body2 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from 'shared/constants';

import logo from './assets/lock.png';
import * as styles from './styles.css';

export interface IBookedFromDeveloperContactsLayoutProps {
  buttons?: React.ReactNode;
}

export const NewbuildingBookedFromDeveloperButton: React.FC<
  React.PropsWithChildren<IBookedFromDeveloperContactsLayoutProps>
> = ({ buttons }) => {
  return (
    <div data-testid="booked-from-developer-button">
      <div className={styles['message']}>
        <div className={styles['logo']}>
          <Image src={logo} height={40} width={40} />
        </div>

        <div className={styles['info']}>
          <div className={styles['title']}>
            <UIHeading4 as="h4">Квартира забронирована</UIHeading4>
          </div>
          <Body2>
            Застройщик может записать вас в{NBSP}очередь или{NBSP}подобрать похожую
          </Body2>
        </div>
      </div>
      {buttons && <div className={styles['buttons']}>{buttons}</div>}
    </div>
  );
};
